import image1 from '../images/pouch.jpg'
import image2 from '../images/charger.jpg'
import image3 from '../images/earbuds.jpg'
import image4 from '../images/cord.jpg'
const accessories = [
  {
    id: '1',
    image: image1,
    name: 'Leather material phone pouch',
    price: '8.99',
    stars: '5',
    numberOfReviews: '8'
  },
  {
    id: '2',
    image: image2,
    name: 'High quality USB Charger power unit',
    price: '5',
    stars: '3',
    numberOfReviews: '10'
  },
  {
    id: '3',
    image: image3,
    name: 'Samsung replacement Earbuds',
    price: '75',
    stars: '2',
    numberOfReviews: '17'
  },
  {
    id: '4',
    image: image4,
    name: 'Mintway USB Cords',
    price: '3.99',
    stars: '4',
    numberOfReviews: '100'
  }
]
export default accessories
